module.exports = __webpack_public_path__ + "static/img/Customers.fw.ecc1413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Customers.fw.png
// module id = 9fXf
// module chunks = 1